<template>
  <div class="content-wrapper">
    <app-overlay-loader v-if="preloader"/>

    <!-- Back Button -->


    <app-breadcrumb :page-title="pageTitle"
                    :directory="$t('datatables')"
                    :icon="'grid'"/>
    <div class="d-flex justify-content-end mb-2">
      <el-button size="mini"
                 style="background-color: #007bff !important; border-color: #007bff !important; color: #fff !important;"
                 icon="el-icon-arrow-left"
                 @click="goBack">
        Back
      </el-button>
    </div>
    <template v-if="isScreeningScheduleExist">
      <div class="row">
        <div class="col-sm-4">
          <timer title="Limited Screening Timer"
                 :endingTime="this.screeningSchedule.limited_screening_due_date"
          />
        </div>
        <div class="col-sm-4">
          <timer title="Screening Timer"
                 :endingTime="this.screeningSchedule.complete_screening_due_date"
          />
        </div>
      </div>
    </template>

    <form ref="form" :data-url="addUrl" method="post">
      <template v-if="isApiLoadComplete">
        <app-tab :tabs="tabsHorizontal"
                 type="customize"
                 @update:licenses="handleLicensesUpdate"/>
        <el-button class="btn btn-primary el-button--default float-right mt-sm-2"
                   @click="saveBtnHandler" v-if="!applicantArchiveId && (active === 0 || active === 1 || active === 3 || active === 5 || active === 6 || active === 8 || active === 9)">
          Apply Changes
        </el-button>
      </template>
    </form>
  </div>
</template>

<script>
import {APPLICANT_INFO_UPDATE} from "@/app/Config/ScreeningAppUrl";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {dateFormatter, saveBtnHandler} from '@Views/Screening/utility/common';
import {_yesOrNoList} from '@Views/Screening/utility/constant';
import {Candidate, Search} from "@Views/Screening/utility/apiAgent";
import {searchType} from "@Views/Screening/utility/enums";

export default {
  name: "CandidateDetail",
  mixins: [FormMixin],
  provide() {
    return {
      getApplicantArchiveId: () => this.applicantArchiveId
    }
  },
  props: {
    screening_schedule: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      pageTitle: "Candidate Detail",
      basicInfo: {},
      payrollInfo: {},
      addressInfo: [],
      applicantSearch: {},
      trainingInfo: [],
      candidateHistoryInfo: [],
      siaInfo: [],
      policyDeclarationInfo: {},
      inputDetails: [],
      gdprInfo: {},
      nextButton: false,
      active: 0,
      lastFormIndex: 8,
      preloader: false,
      registrationForm: {},
      activeIdCollection: [],
      licenses: [],
      tabsHorizontal: [],
      companyInfo : {},
      isApiLoadComplete: false,
      candidateId: 0,
      applicantArchiveId: 0,
      companyId: 0,
      addUrl: APPLICANT_INFO_UPDATE,
      screeningSchedule: {},
      yesOrNoList: _yesOrNoList,
      remainingTime: 0,
      applicantFiles: [],
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
    // Clean up event listeners
    this.$hub.$off('candidateDetailActiveIndex');
    this.$hub.$off('updateSearchItems');
    this.$hub.$off('refresh-verification-steps');
    this.$hub.$off('document-deleted', this.handleDeletedDocument);
  },

   mounted() {
    this.$hub.$on('candidateDetailActiveIndex', (data) => {
      this.active = data;
    })
     this.$hub.$on('updateSearchItems', () => {
       this.getApplicantSearch(this.candidateId);

     })
     // Listen for verification steps refresh events
     this.$hub.$on('refresh-verification-steps', () => {
       // Refresh the applicant details to get updated data
       this.getApplicantDetails(this.candidateId, this.applicantArchiveId);
     })
     this.$hub.$on('document-deleted', this.handleDeletedDocument);
     this.setInitialTabs()
     this.updateRemainingTime();
     this.timer = setInterval(this.updateRemainingTime, 1000);
     this.candidateId = Number(this.$attrs['candidate-id']);
     this.applicantArchiveId = Number(this.$attrs['applicant-archive-id']);
     this.companyId = Number(this.$attrs['company-id']);
     this.addUrl = `${APPLICANT_INFO_UPDATE}/${this.companyId}/${this.candidateId}`;
     this.getApplicantDetails(this.candidateId, this.applicantArchiveId);
     this.getApplicantSearch(this.candidateId);
     this.getApplicantSchedule(this.candidateId);
     this.licenses = (this.basic_info?.licenses && Array.isArray(this.basic_info?.licenses)) ? this.basic_info.licenses : []

  },
  computed: {
    isScreeningScheduleExist() {
      return !!this.screening_schedule?.status;
    },
    formattedTime() {
      const seconds = Math.floor(this.remainingTime / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      if (days > 0) return `${days} day${days > 1 ? 's' : ''} left`;
      if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} left`;
      if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} left`;
      return `${seconds} second${seconds > 1 ? 's' : ''} left`;
    }
  },
  methods: {
    handleDeletedDocument(deletedFile) {
      const deletedType = `${deletedFile?.type || ''}`.toLowerCase();

      if (Array.isArray(this.basicInfo.files)) {
        this.basicInfo.files = this.basicInfo.files.filter((f) => f.id !== deletedFile?.id);
      }

      if (deletedType === 'sialicense' && Array.isArray(this.basicInfo.licenses)) {
        this.basicInfo.licenses = this.basicInfo.licenses.map((license) => {
          if(deletedFile?.id && license.license_id === deletedFile.id){
            license.license_id = null;
            license.license_name = null;
            license.license_path = null;
            license.licensePreview = null;
            license.pending_license_document = null;
          }
          return license;
        });
      }
    },

    handleLicensesUpdate(val) {

      if (JSON.stringify(this.basicInfo.licenses) !== JSON.stringify(val)) {
        this.basicInfo.licenses = val;
      }
    },
    updateRemainingTime() {
      const endTime = new Date(this.screeningSchedule.complete_screening_due_date).getTime();
      const now = Date.now();
      this.remainingTime = Math.max(0, endTime - now);
    },
    dateFormatter,
    saveBtnHandler,
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$set(this.basicInfo, 'employee_picture', null);
      this.$set(this.basicInfo, 'pending_profile_pic', null);
      this.$set(this.basicInfo, 'passport', null);
      this.$set(this.basicInfo, 'pending_passport', null);
      this.$set(this.basicInfo, 'driving_license_document', null);
      this.$set(this.basicInfo, 'pending_driving_license', null);
      this.getApplicantDetails(this.candidateId, this.applicantArchiveId);
    }, afterError(response) {
      this.$toastr.e(response.data.message);
    },
    getApplicantDetails(candidateId, applicantArchiveId = null) {
      this.preloader = true;
      Candidate.getCandidateById(candidateId, applicantArchiveId)
          .then(({data}) => {
            if (data?.applicant && Object.values(data?.applicant).length > 0) {

              this.getApplicantSchedule(data.applicant.screening_schedule);
              this.setApiResponseIntoBasicInfoProps(data.applicant, 0, data.applicant.files);
              this.applicantFiles = data.applicant.files;
              this.companyInfo = data.applicant?.company
              this.setApiResponseIntoPayrollProps(data.applicant?.applicant_payroll, 1);
              this.setApiResponseIntoAddressProps(data.applicant?.applicant_address, 3);
              this.setApiResponseIntoTrainingProps(data.applicant?.applicant_training, 4);
              this.setApiResponseIntoPreviousHistoryProps({
                employment: data.applicant?.applicant_employment,
                education: data.applicant?.applicant_education,
                selfEmployment: data.applicant?.applicant_self_employment,
                unEmployment: data.applicant?.applicant_unemployment
              }, 5);
              this.setApiResponseIntoSIAProps(data.applicant?.applicant_sia_detail, 6);
              this.setUploadDocumentProps(7);
              this.setApiResponseIntoGdprProps(data.applicant?.applicant_gdpr_detail, 8);
              this.setApiResponseIntoPolicyDeclrationProps(data.applicant?.applicant_policy_declaration, 9);
              this.setApiResponseIntoInputDetailsProps(data.applicant?.screeningChecklists, 10, data.applicant.submittedForms);
              this.setApiResponseIntoScreeningEndorsementProps(data.applicant?.screening_schedule, 11);
              this.isApiLoadComplete = true;
              this.preloader = false;
            }
          });
    },
    setApiResponseIntoBasicInfoProps(applicant, index, files = null) {
      this.$set(this.basicInfo, 'employeeImagePreview', null);
      this.$set(this.basicInfo, 'employee_picture_path', null);
      this.$set(this.basicInfo, 'employee_picture_name', null);
      this.$set(this.basicInfo, 'passport_path', null);
      this.$set(this.basicInfo, 'passport_name', null);
      this.$set(this.basicInfo, 'driving_license_path', null);
      this.$set(this.basicInfo, 'driving_license_name', null);

      if (files && Array.isArray(files)) {
        const profilePic = files.find(file => file.type === 'profile_pic');
        if (profilePic) {
          this.$set(this.basicInfo, 'employeeImagePreview', profilePic.file_path);
          this.$set(this.basicInfo, 'employee_picture_path', profilePic.file_path);
          this.$set(this.basicInfo, 'employee_picture_name', profilePic.file_name);
          this.$set(this.basicInfo, 'employee_picture_id', profilePic.id);
        }

        const passport = files.filter(f => f.type === 'passport').reduce((prev, current) => {
          return (Number(current.id) > (Number(prev?.id) || 0)) ? current : prev;
        }, null);

        if (passport) {
          this.$set(this.basicInfo, 'passport_path', passport.file_path);
          this.$set(this.basicInfo, 'passport_name', passport.file_name);
          this.$set(this.basicInfo, 'passport_id', passport.id);
        }

        const drivingLicense = files.filter(f => f.type === 'driving_license').reduce((prev, current) => {
          return (Number(current.id) > (Number(prev?.id) || 0)) ? current : prev;
        }, null);

        if (drivingLicense) {
          this.$set(this.basicInfo, 'driving_license_path', drivingLicense.file_path);
          this.$set(this.basicInfo, 'driving_license_name', drivingLicense.file_name);
          this.$set(this.basicInfo, 'driving_license_id', drivingLicense.id);
        }
      }

      this.$set(this.basicInfo, 'driving_license_path', this.basicInfo.driving_license_path || null);
      this.$set(this.basicInfo, 'driving_license_name', this.basicInfo.driving_license_name || null);
      this.$set(this.basicInfo, 'pending_driving_license', null);
      this.$set(this.basicInfo, 'drivingLicensePreview', null);
      this.$set(this.basicInfo, 'driving_license_document', null);

      this.$set(this.basicInfo, 'currentAddress', applicant.currentAddress);
      this.$set(this.basicInfo, 'position_applied', applicant.position_applied);
      this.$set(this.basicInfo, 'full_name', applicant.full_name);
      this.$set(this.basicInfo, 'id', applicant.id);
      this.$set(this.basicInfo, 'forename', applicant.forename);
      this.$set(this.basicInfo, 'middle_name', applicant.middle_name);
      this.$set(this.basicInfo, 'surname', applicant.surname);
      this.$set(this.basicInfo, 'n_i_number', applicant.n_i_number);
      this.$set(this.basicInfo, 'gender', applicant.gender);
      this.$set(this.basicInfo, 'date_of_birth', applicant.date_of_birth);
      this.$set(this.basicInfo, 'title', applicant.title);
      this.$set(this.basicInfo, 'country_of_birth', applicant.country_of_birth);
      this.$set(this.basicInfo, 'town_of_birth', applicant.town_of_birth);
      this.$set(this.basicInfo, 'photo_id_match', applicant.photo_id_match);
      this.$set(this.basicInfo, 'nationality', applicant.nationality);
      this.$set(this.basicInfo, 'edbs_number', applicant.edbs_number);
      this.$set(this.basicInfo, 'contact_number', applicant.contact_number ?? '');
      this.$set(this.basicInfo, 'alternative_contact_no', applicant.alternative_contact_no ?? '');
      this.$set(this.basicInfo, 'email', applicant.email);
      this.$set(this.basicInfo, 'additional_email', applicant.additional_email);
      this.$set(this.basicInfo, 'report_email', applicant.report_email || 'primary');
      this.$set(this.basicInfo, 'relationship', applicant.relationship);
      this.$set(this.basicInfo, 'next_of_kin', applicant.next_of_kin);
      this.$set(this.basicInfo, 'next_of_kin_contact_no', applicant.next_of_kin_contact_no ?? '');
      this.$set(this.basicInfo, 'is_sia_required', applicant.is_sia_required === 1 ? true : false);
      this.$set(this.basicInfo, 'sia_license_number', applicant.sia_license_number);
      this.$set(this.basicInfo, 'sia_license_type', applicant.sia_license_type);
      this.$set(this.basicInfo, 'sia_license_expiry', applicant.sia_license_expiry);
      this.$set(this.basicInfo, 'is_additional_license', applicant.is_additional_license === 1 ? true : false);
      this.$set(this.basicInfo, 'additional_sia_license_number', applicant.additional_sia_license_number);
      this.$set(this.basicInfo, 'additional_sia_license_type', applicant.additional_sia_license_type);
      this.$set(this.basicInfo, 'additional_sia_license_expiry', applicant.additional_sia_license_expiry);
      this.$set(this.basicInfo, 'share_code', applicant.share_code);
      this.$set(this.basicInfo, 'files', applicant.files);
      this.$set(this.basicInfo, 'share_code_start_date', applicant.share_code_start_date);
      this.$set(this.basicInfo, 'employee_picture', applicant.employee_picture);
      this.$set(this.basicInfo, 'is_visa_require_uk', applicant.is_visa_require_uk);
      this.$set(this.basicInfo, 'visa_type', applicant.visa_type);
      this.$set(this.basicInfo, 'biometric_residence_permit', applicant.biometric_residence_permit);
      this.$set(this.basicInfo, 'visa_expiry', applicant.visa_expiry);
      this.$set(this.basicInfo, 'date_of_entry_re_entry', applicant.date_of_entry_re_entry);
      this.$set(this.basicInfo, 'is_have_p45_or_p46', applicant.is_have_p45_or_p46);
      this.$set(this.basicInfo, 'copy_of_p45', applicant.copy_of_p45);
      this.$set(this.basicInfo, 'p46_detail', applicant.p46_detail);
      this.$set(this.basicInfo, 'is_other_employment', applicant.is_other_employment);
      this.$set(this.basicInfo, 'continue_other_employment', applicant.continue_other_employment);
      this.$set(this.basicInfo, 'is_leisure', applicant.is_leisure);
      this.$set(this.basicInfo, 'leisure_details', applicant.leisure_details);
      this.$set(this.basicInfo, 'is_criminal_record', applicant.is_criminal_record);
      this.$set(this.basicInfo, 'criminal_record_details', applicant.criminal_record_details);
      this.$set(this.basicInfo, 'is_bankruptcy', applicant.is_bankruptcy);
      this.$set(this.basicInfo, 'bankruptcy_details', applicant.bankruptcy_details);
      this.$set(this.basicInfo, 'is_days_shift_cant_work', applicant.is_days_shift_cant_work);
      this.$set(this.basicInfo, 'days_shift_cant_work_details', applicant.days_shift_cant_work_details);
      this.$set(this.basicInfo, 'is_holidays_commitment', applicant.is_holidays_commitment);
      this.$set(this.basicInfo, 'holidays_commitment_details', applicant.holidays_commitment_details);
      this.$set(this.basicInfo, 'is_own_vehicle', applicant.is_own_vehicle);
      this.$set(this.basicInfo, 'is_driving_license', applicant.is_driving_license);
      this.$set(this.basicInfo, 'driver_license_number', applicant.driver_license_number);
      this.$set(this.basicInfo, 'license_type', applicant.license_type);
      this.$set(this.basicInfo, 'license_issue_date', applicant.license_issue_date);
      this.$set(this.basicInfo, 'license_expiry_date', applicant.license_expiry_date);
      this.$set(this.basicInfo, 'statusable_type', applicant.statusable_type);
      this.$set(this.basicInfo, 'screening_status', applicant.screening_status);
      if (applicant.licenses && Array.isArray(applicant.licenses) && files && Array.isArray(files)) {
        const cleanedLicenses = applicant.licenses.map(license => {
          if (license.license_id) {
            const fileExists = files.some(f => f.id == license.license_id);
            if (!fileExists) {
              return {
                ...license,
                license_id: null,
                license_path: null,
                license_name: null,
                licensePreview: null,
                pending_license_document: null,
                license_document: null
              };
            }
          }
          return license;
        });
        this.$set(this.basicInfo, 'licenses', cleanedLicenses);
      } else {
        this.$set(this.basicInfo, 'licenses', applicant.licenses);
      }
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          basic_info: this.basicInfo,
          yesOrNoList: this.yesOrNoList,
          isAdmin: true,
          candidateId: this.candidateId,
          onSaveBtn: this.saveBtnHandler,
        }
      });
    },
    setApiResponseIntoPayrollProps(payroll, index) {
      if (payroll && Object.values(payroll).length > 0) {
        this.$set(this.payrollInfo, 'id', payroll.id);
        this.$set(this.payrollInfo, 'account_name', payroll.account_name);
        this.$set(this.payrollInfo, 'account_number', payroll.account_number);
        this.$set(this.payrollInfo, 'bank_name', payroll.bank_name);
        this.$set(this.payrollInfo, 'other_information', payroll.other_information);
        this.$set(this.payrollInfo, 'sort_code', payroll.sort_code);
        this.$set(this.payrollInfo, 'statusable_type', payroll.statusable_type);
        this.$set(this.payrollInfo, 'screening_status', payroll.screening_status);
      }
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          payroll_info: this.payrollInfo,
          isAdmin: true,
          candidateId: this.candidateId,
          emailAddress: this.basicInfo.email,
        }
      });
    },
    setApiResponseIntoAddressProps(address, index) {
      if (this.addressInfo && Array.isArray(this.addressInfo)) {
        this.addressInfo.splice(0);
      }
      if (address && address.length > 0) {
        this.addressInfo.push(...address);
      }
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          address_Info: this.addressInfo,
          screeningSchedule: this.screeningSchedule,
          dateFormatter: this.dateFormatter,
          isAdmin: true,
          candidateId: this.candidateId,
          emailAddress: this.basicInfo.email,
          onSaveBtn: this.saveBtnHandler,
          restrictValidation: true,
        }
      });
    },
    addSocialMediaCheck(parentIndex, value) {
      this.applicantSearch[parentIndex].push(value)
    },
    setSearchComponentProps(index) {
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          candidate: this.basicInfo,
          address: this.addressInfo,
          applicantSearch: this.applicantSearch,
          socialMediaChecks: this.socialMediaChecks,
          onAddCheck: this.addSocialMediaCheck
        }
      });
    },
    setApiResponseIntoTrainingProps(training, index) {
      if (this.trainingInfo && Array.isArray(this.trainingInfo)) {
        this.trainingInfo.splice(0);
      }
      if (training && training.length > 0) {
        this.trainingInfo.push(...training);
      }
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          yesOrNoList: _yesOrNoList,
          training_info: this.trainingInfo,
          dateFormatter: this.dateFormatter,
          isAdmin: true,
          candidateId: this.candidateId,
          emailAddress: this.basicInfo.email,
          onSaveBtn: this.saveBtnHandler,
          screeningSchedule: this.screeningSchedule,
        }
      });
    },
    setApiResponseIntoPreviousHistoryProps(previousHistory, index) {
      if (this.candidateHistoryInfo && Array.isArray(this.candidateHistoryInfo)) {
        this.candidateHistoryInfo.splice(0);
      }
      if (previousHistory.employment && previousHistory.employment.length > 0) {
        for (const employment of previousHistory.employment) {
          this.candidateHistoryInfo.push({...employment, type: 0});
        }
      }
      if (previousHistory.education && previousHistory.education.length > 0) {
        for (const education of previousHistory.education) {
          this.candidateHistoryInfo.push({...education, type: 1});
        }
      }
      if (previousHistory.selfEmployment && previousHistory.selfEmployment.length > 0) {
        for (const selfEmployment of previousHistory.selfEmployment) {
          this.candidateHistoryInfo.push({...selfEmployment, type: 2});
        }
      }
      if (previousHistory.unEmployment && previousHistory.unEmployment.length > 0) {
        for (const unEmployment of previousHistory.unEmployment) {
          this.candidateHistoryInfo.push({...unEmployment, type: 3});
        }
      }
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          yesOrNoList: _yesOrNoList,
          candidate_history_info: this.candidateHistoryInfo,
          dateFormatter: this.dateFormatter,
          isAdmin: true,
          candidateId: this.candidateId,
          emailAddress: this.basicInfo.email,
          onSaveBtn: this.saveBtnHandler,
          applicant: this.basicInfo,
          company: this.companyInfo,
        }
      });
    },
    setApiResponseIntoSIAProps(sia, index) {
      if (sia && sia.length > 0) {
        this.siaInfo = sia;
      }
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          sia_Info: this.siaInfo,
          isAdmin: true
        }
      });
    },
    setUploadDocumentProps(index) {
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          emailAddress: this.basicInfo.email,
          isAdmin: true,
          candidateId: this.candidateId,
          screeningSchedule: this.screeningSchedule,
        }
      });
    },
    setApiResponseIntoGdprProps(gdpr, index) {
      if (gdpr && Object.values(gdpr).length > 0) {
        this.$set(this.gdprInfo, 'id', gdpr.id);
        this.$set(this.gdprInfo, 'consent', gdpr.consent === 1 ? true : false);
        this.$set(this.gdprInfo, 'consent_date_time', gdpr.consent_date_time);
        this.$set(this.gdprInfo, 'special_category_data', gdpr.special_category_data === 1 ? true : false);
        this.$set(this.gdprInfo, 'statusable_type', gdpr.statusable_type);
        this.$set(this.gdprInfo, 'criminal', gdpr.criminal);
        this.$set(this.gdprInfo, 'financial', gdpr.financial);
        this.$set(this.gdprInfo, 'health', gdpr.health);
        this.$set(this.gdprInfo, 'diversity', gdpr.diversity);
        this.$set(this.gdprInfo, 'biometric', gdpr.biometric);
        this.$set(this.gdprInfo, 'signature', gdpr.signature);

      }
      // this.$set(this.gdprInfo, 'companyInfo', this.companyInfo);
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          gdpr_info: this.gdprInfo,
          companyInfo: this.companyInfo,
          isAdmin: true,
          candidateId: this.candidateId,
        }
      });
    },
    setApiResponseIntoPolicyDeclrationProps(policyDeclration, index) {
      if (policyDeclration && Object.values(policyDeclration).length > 0) {
        this.$set(this.policyDeclarationInfo, 'id', policyDeclration.id);
        this.$set(this.policyDeclarationInfo, 'applicant_screening', policyDeclration.applicant_screening === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'criminal_background_check', policyDeclration.criminal_background_check === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'declaration_by_applicant', policyDeclration.declaration_by_applicant === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'financial_history', policyDeclration.financial_history === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'equality', policyDeclration.equality === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'equality_details', policyDeclration.equality_details);
        this.$set(this.policyDeclarationInfo, 'working_time_directive', policyDeclration.working_time_directive);
        this.$set(this.policyDeclarationInfo, 'statusable_type', policyDeclration.statusable_type);
      }
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          policy_declaration: this.policyDeclarationInfo,
          yesOrNoList: _yesOrNoList,
          isAdmin: true,
          candidateId: this.candidateId,
        }
      });
    },
    setApiResponseIntoInputDetailsProps(screeningChecklists, index, submittedForms) {
      if (screeningChecklists && Object.values(screeningChecklists).length > 0) {
        this.inputDetails = Object.values(screeningChecklists).sort((a, b) => a.order - b.order);
      }

      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          applicantScreeningCheckpoint: this.inputDetails,
          candidateId: this.candidateId,
          companyId: this.companyId,
          applicantFiles: this.applicantFiles,
          submittedForms: submittedForms,
          screeningSchedule: this.screeningSchedule,
        }
      });
    },
    setApiResponseIntoScreeningEndorsementProps(screening_schedule, index) {
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          screening_schedule: screening_schedule,
          candidateId: this.candidateId,
          companyId: this.companyId,

        }
      });
    },

    getApplicantSearch(candidate) {
      this.preloader = true;

      Search.getApplicantSearch(candidate)
          .then(({data}) => {

            this.$set(this.applicantSearch, 'currentAddress', this.basicInfo.currentAddress);
            this.$set(this.applicantSearch, searchType.SIA, data[searchType.SIA]);
            this.$set(this.applicantSearch, searchType.Credits, data[searchType.Credits]);
            this.$set(this.applicantSearch, searchType.RightToWork, data[searchType.RightToWork]);
            this.$set(this.applicantSearch, searchType.FinancialSanctions, data[searchType.FinancialSanctions]);
            this.$set(this.applicantSearch, searchType.DrivingLicense, data[searchType.DrivingLicense]);
            this.$set(this.applicantSearch, searchType.socialMediaChecks, data[searchType.socialMediaChecks]);
            this.setSearchComponentProps(2);
            this.preloader = false;
          });

    },
    getApplicantSchedule(candidateSchedule) {
      if (candidateSchedule && Object.keys(candidateSchedule).length > 0) {

        const newSchedule = {
          id: candidateSchedule.id,
          applicant_id: candidateSchedule.applicant_id,
          complete_screening_due_date: candidateSchedule.complete_screening_due_date,
          limited_screening_due_date: candidateSchedule.limited_screening_due_date,
          start_date: candidateSchedule.start_date,
          created_at: candidateSchedule.created_at,
          status: candidateSchedule.status,
          deployment_date: candidateSchedule.deployment_date,
          previous_history_duration: candidateSchedule.previous_history_duration,
        };
        // Clear old keys and assign new ones to preserve reference
        Object.keys(this.screeningSchedule).forEach(key => this.$delete(this.screeningSchedule, key));
        Object.assign(this.screeningSchedule, newSchedule);
      } else {
        Object.keys(this.screeningSchedule).forEach(key => this.$delete(this.screeningSchedule, key));
      }
      this.$set(this.basicInfo, 'screeningSchedule', this.screeningSchedule);
      this.$set(this.payrollInfo, 'screeningSchedule', this.screeningSchedule);
      this.$set(this.addressInfo, 'screeningSchedule', this.screeningSchedule);
      this.$set(this.trainingInfo, 'screeningSchedule', this.screeningSchedule);
      this.$set(this.candidateHistoryInfo, 'screeningSchedule', this.screeningSchedule);
    },
    goBack() {
      if (document.referrer && document.referrer !== window.location.href) {
        window.location.href = document.referrer;
      } else {
        window.location.href = '/candidates'; // change this to your default/fallback page
      }
    },
    setInitialTabs(){
      this.tabsHorizontal = [
        {
          icon: "info",
          name: "Candidate Basic Info",
          component: "basic-info",
          permission: "",
          props: {}
        },
        {
          icon: "briefcase",
          name: "Bank A/C Details",
          component: "payroll-info",
          permission: "",
          props: {}
        },
        {
          icon: "search",
          name: "Search",
          component: "candidate-detail-search",
          permission: this.isScreeningScheduleExist,
          props: {}
        },
        {
          icon: "home",
          name: "Addresses",
          component: "address-info",
          permission: "",
          props: {}
        },
        {
          icon: "award",
          name: "Training",
          component: "training-info",
          permission: "",
          props: {}
        },
        {
          icon: "phone-outgoing",
          name: "Previous History",
          component: "candidate-history",
          permission: "",
          props: {}
        },
        {
          icon: "zap",
          name: "SIA Questionnaire",
          component: "sia-info",
          permission: "",
          props: {}
        },
        {
          icon: "folder",
          name: "Upload Documents",
          component: "uploaded-documents-info",
          permission: "",
          props: {}
        },
        {
          icon: "user",
          name: "GDPR Notice",
          component: "gdpr-notice-info",
          permission: "",
          props: {}
        },
        {
          icon: "user-check",
          name: "Policy and Declaration",
          component: "policy-declaration-info",
          permission: "",
          props: {}
        },
        {
          icon: "bar-chart-2",
          name: "Input Details",
          component: "input-details",
          permission: this.isScreeningScheduleExist,
          props: {}
        },
        {
          icon: "edit-3",
          name: "Screening Remarks",
          component: "screening-remarks",
          permission: this.isScreeningScheduleExist,
          props: {}
        }
      ];
    },
  }
}
</script>
